import { render, staticRenderFns } from "./whatnowSummaryItem.vue?vue&type=template&id=7648f51b&scoped=true"
import script from "./whatnowSummaryItem.vue?vue&type=script&lang=js"
export * from "./whatnowSummaryItem.vue?vue&type=script&lang=js"
import style0 from "./whatnowSummaryItem.vue?vue&type=style&index=0&id=7648f51b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648f51b",
  null
  
)

export default component.exports